export enum PlanningTipTypes {
    attention = "attention",
    ai = "ai",
    alert = "alert"
}